import { render, staticRenderFns } from "./StorageSpaceMediaDelete.vue?vue&type=template&id=a205382e&"
import script from "./StorageSpaceMediaDelete.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceMediaDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports